import { apps, AppShortcut } from '@/config/ecosystem';
import React from 'react';

export const Homepage: React.FC = () => {
  const openApp = (url: string): void => {
    window.open(url, '_blank');
  };

  return (
    <div className='min-h-screen bg-gray-50'>
      {/* Header Section */}
      <div className='px-6 py-16'>
        <div className='text-center max-w-4xl mx-auto'>
          <div className='mb-12'>
            <h1 className='text-4xl sm:text-5xl font-bold text-gray-800 mb-4 leading-tight'>
              Welcome to MindX
            </h1>
            <div className='w-16 h-0.5 bg-gray-400 mx-auto mb-6'></div>
            <p className='text-lg text-gray-600 leading-relaxed'>
              Truy cập nhanh đến các ứng dụng MindX
            </p>
          </div>
        </div>
      </div>

      {/* Apps Grid Section */}
      <div className='px-6 pb-20'>
        <div className='max-w-7xl mx-auto'>
          {/* Single Row - All 5 items */}
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 justify-items-center'>
            {apps.map((app: AppShortcut, index: number) => (
              <div
                key={app.title}
                className='group relative transform transition-all duration-300 hover:scale-105 cursor-pointer w-full max-w-xs'
                onClick={() => openApp(app.url)}
              >
                {/* Card with Logo Background */}
                <div className='relative rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden group h-48 bg-white'>
                  {/* Colored Background Layer */}
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${app.gradient} opacity-30 group-hover:opacity-50 transition-opacity duration-300`}
                  ></div>

                  {/* Logo Background */}
                  <div className='absolute inset-0 flex items-center justify-center'>
                    <img
                      src={`/static/assets/images/${app.imageName}`}
                      alt={`${app.title} logo`}
                      className='w-full h-full object-contain opacity-60 group-hover:opacity-80 transition-opacity duration-300 p-8 filter drop-shadow-sm'
                    />
                  </div>

                  {/* Overlay Background */}
                  <div className='absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>

                  {/* Content Overlay */}
                  <div className='absolute inset-0 flex flex-col justify-end p-6 text-center'>
                    <p className='text-sm text-gray-700 leading-relaxed opacity-0 group-hover:opacity-100 group-hover:text-gray-200 drop-shadow transition-all duration-300 transform group-hover:translate-y-0 translate-y-4'>
                      {app.description}
                    </p>
                  </div>
                  <div className='absolute inset-0 border-2 border-transparent group-hover:border-white/50 rounded-xl transition-all duration-300'></div>
                </div>
                <h3 className='text-center text-gray-800 pt-4 text-2xl'>{app.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
